/**
 * Logic for ShareLinks component (see also _ShareLinks.scss)
 * Trigger print, and open sharing links in a new window
 */
;(function(jQuery){
	"use strict";
	function ProjectsAbroadShareLinks()
	{
		var global = {
		}

		var fn = {
			init: function()
			{
				jQuery('.js-share-link').on('click', fn.handleShare);
			},

			handleShare: function(e)
			{
				e.preventDefault();
				var sharetype = jQuery(this).attr('data-sharetype');
				if (sharetype === 'print')
				{
					window.print();
				}
				else
				{
					fn.openInNewWindow(jQuery(this).attr('href'));
				}
			},

			openInNewWindow: function(href)
			{
				var leftPos = Math.round((screen.width / 2) - (550 / 2));
				var topPos = 0;

				if (screen.height > 420) {
					topPos = Math.round((screen.height / 2) - (550 / 2));
				}

				var shareWindow = window.open(href, 'projectsabroad_sharewindow', 'scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,left=' + leftPos + ',top=' + topPos);
				shareWindow.focus();
			}
		}

		jQuery(fn.init);
	}

	new ProjectsAbroadShareLinks();
}($));
